import * as React from 'react';
import { SVGProps } from 'react';

const SvgMarketStats = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={17} height={16} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.998 1.715a.75.75 0 1 0-1.5 0v12.57c0 .414.336.75.75.75h14.504a.75.75 0 0 0 0-1.5H1.998V1.715Zm1.184 11.386c2.245 0 3.75-.739 4.826-1.903 1.015-1.097 1.602-2.534 2.128-3.82l.025-.061c.555-1.358 1.053-2.552 1.866-3.431.767-.83 1.86-1.421 3.725-1.421a.75.75 0 0 0 0-1.5c-2.245 0-3.75.739-4.827 1.903-1.014 1.097-1.601 2.534-2.127 3.82l-.025.061C8.217 8.107 7.72 9.301 6.907 10.18c-.768.83-1.86 1.421-3.725 1.421a.75.75 0 0 0 0 1.5Z"
      fill="#174174"
    />
  </svg>
);

export default SvgMarketStats;
